import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';
import smoothScroll from '../../utils/smoothScroll';

const Footer = () => {
    const { t } = useTranslation();
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const location = useLocation();

    useEffect(() => {
        // This effect is not strictly needed if the year won't change during component lifecycle
        // but good practice if it could be a long-lived app where the year might roll over.
        setCurrentYear(new Date().getFullYear());
    }, []);

    const footerLinkKeys = [
        { id: 'products', labelKey: 'footer.links.ourKits' },
        { id: 'installation', labelKey: 'footer.links.installation' },
        { id: 'software-interactive', labelKey: 'footer.links.software' },
        { id: 'benefits', labelKey: 'footer.links.advantages' },
        { id: 'mobile-app-feature', labelKey: 'footer.links.mobileApp' },
    ];

    const handleSmoothScrollOrNavigate = (e, targetId) => {
        if (location.pathname === '/') {
            smoothScroll(e, targetId);
        } else {
            // If not on main page, Link component will handle navigation to '/'
            // and then an effect in App or MainPageLayout could scroll to #hero if needed.
            // For now, Link to '/' is sufficient.
        }
    };

    return (
        <footer className={styles.footer}>
            <div className={`container ${styles.footerContainer}`}> {/* Global container, specific padding from CSS */}
                <p>{t('footer.copyright', { year: currentYear })}</p>
                <p>
                    <Link to="/" className={styles.footerLink} onClick={(e) => handleSmoothScrollOrNavigate(e, 'hero')}>{t('footer.links.home')}</Link>
                    {footerLinkKeys.length > 0 && ' | '}
                    {footerLinkKeys.map((link, index) => (
                        <React.Fragment key={link.id}>
                            {location.pathname === '/' ? (
                                <a href={`#${link.id}`} className={styles.footerLink} onClick={(e) => smoothScroll(e, link.id)}>{t(link.labelKey)}</a>
                            ) : (
                                <Link to={`/#${link.id}`} className={styles.footerLink}>{t(link.labelKey)}</Link>
                            )}
                            {index < footerLinkKeys.length - 1 && ' | '}
                        </React.Fragment>
                    ))}
                    {(footerLinkKeys.length > 0 || location.pathname !== '/privacy-policy') && ' | '}
                    <Link to="/privacy-policy" className={styles.footerLink}>{t('footer.links.privacyPolicy')}</Link>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
